import consts from '@/config/consts'

export default {
  computed: {
    inventoryTypeID () {
      return consts.schedules.INVENTORY_TYPE_ID
    },
    serviceTypeID () {
      return consts.schedules.SERVICE_TYPE_ID
    },
    caseManagerTypeID () {
      return consts.schedules.CASEMANAGER_TYPE_ID
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/ItemTypes.js